import React, { useEffect } from 'react';
import { MapPin, Phone, Mail, Send } from 'lucide-react';

import './ContactUs.css';
import Navbar from '../LandingPage/Navbar';
import Footer from '../LandingPage/Footer';

const ContactUs = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Our team will contact you shortly.");
  };

  return (
    <div className="contact-page">
      <Navbar />

      {/* --- 1. Hero Section (Behind Transparent Navbar) --- */}
      <div className="contact-hero">
        <div className="hero-overlay-dark"></div>
        <div className="container hero-text-center">
          <h1 className="page-title-large">Contact Us</h1>
          <p className="page-subtitle-white">We are here to assist you with your realty journey.</p>
        </div>
      </div>

      {/* --- 2. Main Content Grid --- */}
      <section className="section-padding bg-cream">
        <div className="container">
          <div className="contact-grid">
            
            {/* --- Left Side: Help Desk / Office Image --- */}
            <div className="help-desk-wrapper">
              <div className="image-frame-premium">
                {/* Modern Laptop/Office Workspace Image */}
<img
  src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80"
  alt="Professional office reception"
  className="help-desk-img"
/>

                
                {/* Overlay Card for Contact Info */}
                <div className="info-overlay-card">
                  <h3>Reach Out Directly</h3>
                  <div className="c-row">
                    <Phone size={18} className="icon-gold" />
                    <span>+91 98765 43210</span>
                  </div>
                  {/* <div className="c-row">
                    <Mail size={18} className="icon-gold" />
                    <span>info@propertygalleria.com</span>
                  </div> */}
                </div>
              </div>
            </div>

            {/* --- Right Side: Premium Form --- */}
            <div className="form-wrapper-luxury">
              <div className="form-header-box">
                <span className="sub-gold">Get In Touch</span>
                {/* <h2>Start Your Investment</h2> */}
              </div>

              <form onSubmit={handleSubmit} className="luxury-form">
                
                {/* Name */}
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" placeholder="John" required />
                </div>

                {/* Mobile & Email (Grid on Desktop) */}
                <div className="form-row-2">
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input type="tel" placeholder="+91 98765 43210" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address</label>
                    <input type="email" placeholder="john@example.com" required />
                  </div>
                </div>

                {/* Property Selection */}
                <div className="form-group">
                  <label>Select Property Type</label>
                  <div className="select-wrapper">
                    <select required defaultValue="">
                      <option value="" disabled>-- Choose an Option --</option>
                      <option value="Residential">Residential (Flats, Villas)</option>
                      <option value="Commercial">Commercial (Offices, Shops)</option>
                      <option value="Industrial">Industrial (Warehouses)</option>
                      <option value="Agricultural">Agricultural (Farmlands)</option>
                      <option value="Rental">Rental / Income Generating</option>
                    </select>
                  </div>
                </div>

                {/* Message */}
                <div className="form-group">
                  <label>Your Message</label>
                  <textarea rows="4" placeholder="Tell us about your requirements..."></textarea>
                </div>

                {/* Submit Button */}
                <button type="submit" className="btn-luxury-submit">
                  Send Message <Send size={18} />
                </button>

              </form>
            </div>

          </div>
        </div>
      </section>
      

      <Footer />
    </div>
  );
};

export default ContactUs;